import FacebookIcon from './Facebook'
import LinkedinIcon from './Linkedin'
import TwitterIcon from './Twitter'
import ZaloIcon from './Zalo'
import FacebookIconColorFull from './FacebooksColorFull'
import LinkedinIconColorFull from './LinkedinColorFull'
import TwitterIconColorFull from './TwitterColorFull'
import ZaloIconColorFull from './ZaloColorFull'
import ShareIcon from './Share'
const SocialMedia = {
    FacebookIconColorFull,
    LinkedinIconColorFull,
    TwitterIconColorFull,
    ZaloIconColorFull,
    FacebookIcon,
    LinkedinIcon,
    TwitterIcon,
    ZaloIcon,
    ShareIcon
}

export default SocialMedia
